import { useReducer, useMemo } from 'react';

type Params = {
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  page: number;
  limit: number;
  search?: string;
  storeId: string;
  userId: string;
  userType?: string;
  transactionType?: string;
  fromDate?: string;
  toDate?: string;
  type?: string;
  settlementUserType?: string;
  settlementUserId?: string;
};

const getInitialParams = (): Params => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  console.log('userData --->', userData);
  const storeId = userData?.userDetails?.storeId || undefined;
  // Fix: Use the correct userId from userData, not a hardcoded value
  const userType ='ADMIN'
  return {
    sortBy: 'createdAt',
    sortOrder: 'desc',
    page: 1,
    limit: 10,
    search: undefined,
    storeId,
    userId: userData?.userId || '',
    userType,
    transactionType: 'all',
    settlementUserType: undefined,
    settlementUserId: undefined
  };
};


type Action =
  | { type: 'SET_SEARCH'; payload: string | undefined }
  | { type: 'SET_PAGE'; payload: number }
  | { type: 'SET_LIMIT'; payload: number }
  | { type: 'SET_SORT'; payload: { sortBy: string; sortOrder: 'asc' | 'desc' } }
  | { type: 'SET_FILTERS'; payload: Partial<Params>; resetPage?: boolean }
  | { type: 'SET_FROM_DATE'; payload: string | undefined }
  | { type: 'SET_TO_DATE'; payload: string | undefined }
  | { type: 'RESET' };

function reducer(state: Params, action: Action): Params {
  console.log('state params', action,state);
  switch (action.type) {
    case 'SET_SEARCH':
      return { ...state, search: action.payload };
    case 'SET_PAGE':
      return state.page === action.payload ? state : { ...state, page: action.payload };
    case 'SET_LIMIT':
      return { ...state, limit: action.payload};
    case 'SET_SORT':
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
      };
    case 'SET_FROM_DATE':
      return { ...state, fromDate: action.payload };
    case 'SET_TO_DATE':
      return { ...state, toDate: action.payload };
    case 'SET_FILTERS':
      return {
        ...state,
        ...Object.fromEntries(
          Object.entries(action.payload).map(([key, val]) => [key, val === '' ? undefined : val])
        ),
      };
    case 'RESET':
      return getInitialParams();
    default:
      console.log('default state', state);
      return state;
  }
}

export function useManageSettlements() {
  const [params, dispatch] = useReducer(reducer, getInitialParams());
  console.log('params', params);
  const stableParams = useMemo(() => {
    // Only include date parameters if both fromDate and toDate are present
    const { fromDate, toDate, ...otherParams } = params;
    if (fromDate && toDate) {
      return { ...otherParams, fromDate, toDate };
    }
    console.log('otherParams', otherParams);

    return otherParams;
  }, [
    params.sortBy,
    params.sortOrder,
    params.page,
    params.limit,
    params.search,
    params.storeId,
    params.userId,
    params.userType,
    params.transactionType,
    params.fromDate,
    params.toDate,
    params.type,
    params.settlementUserType,
    params.settlementUserId
  ]);

  return { params: stableParams, dispatch };
}
